import { render, staticRenderFns } from "./AutoLogin.vue?vue&type=template&id=0a0a9daf&scoped=true&"
import script from "./AutoLogin.vue?vue&type=script&lang=js&"
export * from "./AutoLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0a9daf",
  null
  
)

export default component.exports